import React, { PureComponent } from 'react';
import RowHistorialIntentos from './RowHistorialIntentos';

class TablaHistorialIntentos extends PureComponent {

    constructor(props) {
        super(props);
    }
    render() { 
        const {datosLogIntentos} = this.props
        return (
            <div>
                <table className='width100 tableHistorialLog'>
                    <thead className='saldoHeaderBorde'>
                        <tr className='height50 paddingLeftL paddingTopBottom'>
                            <th width="20%" style={{ paddingLeft:"10px" }}>ID de SAGA</th>
                            <th style={{width:"65%", paddingLeft:"40px"}}>MENSAJE DE ERROR</th>
                            <th width="15%" style={{ padding:"0" }}>FECHA</th>
                        </tr>
                    </thead>
                    <tbody className="contenedorDatosEjecucionProcesosScroll">
                       { datosLogIntentos && datosLogIntentos.length > 0 ?
                             datosLogIntentos.map((a,index) => <RowHistorialIntentos valor={a} index={index}></RowHistorialIntentos>)
                            :
                            <tr className='Personeria paddingLeftXS paddingTopBottom'>
                                <td colSpan="3">{"No hay datos para mostrar"}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}
export default TablaHistorialIntentos;